import Vue from 'vue'
import App from './App.vue'
import router from './router'
//import axios from 'axios';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import UmyUi from 'umy-ui'
import 'umy-ui/lib/theme-chalk/index.css'
import './assets/css/icon.css';
import axios from 'axios';
import './components/common/directives';
import "babel-polyfill";
import GeminiScrollbar from 'vue-gemini-scrollbar'
import Print from './utils/print.js'

Vue.config.productionTip = false
Vue.use(ElementUI, {
    size: 'mini'
});
Vue.use(UmyUi);
Vue.use(GeminiScrollbar);
Vue.use(Print);
//Vue.$axios = axios;
window.ax = axios;
import basejs from "./utils/baseJS.js";
Vue.prototype.baseJS = basejs;
import api from "./utils/api.js";
import dev from "./utils/dev.js";
Vue.prototype.api = api;
Vue.prototype.dev = dev;

//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
    let sign = localStorage.getItem('ms_usign');
    sign = sign ? sign : '';
    let net = localStorage.getItem('ms_net');
    net = net ? net : '';
    let compare = localStorage.getItem('ms_compare');
    compare = compare ? compare : '';
    window.ax.post('/api/authorize/check', {
        Sign: sign,
        Net: net,
        Compare: compare
    }).then(rsp => {
        if (rsp.data == 0) {
            next();
        } else if (rsp.data == 1) {
            if (to.path !== '/login') {
                next('/login');
            } else {
                next();
            }
        } else if (rsp.data == 2) {
            window.location.href = 'api/authorize/check?sign=' + sign + '&path=' + to.path;
        }
    });
});

new Vue({
    router,
    render: h => h(App)
}).$mount('#app');

function dateFormat(date, fmt) {
    if (null == date || undefined == date) return '';
    var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "S": date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" +
                o[k])
            .substr(("" + o[k]).length)));
    return fmt;
};

Date.prototype.toDateString = function() {
    return dateFormat(this, 'yyyy-MM-dd hh:mm:ss')
};
Date.prototype.toDateFormatString = function(format) {
    return dateFormat(this, format);
};
String.prototype.PadLeft = function(len, charStr) {
    var s = this + '';
    if (s.length >= len) {
        return s;
    }
    return new Array(len - s.length + 1).join(charStr || '') + s;
}
String.prototype.PadRight = function(len, charStr) {
    var s = this + '';
    if (s.length >= len) {
        return s;
    }
    return s + new Array(len - s.length + 1).join(charStr || '');
}
Blob.prototype.getURL = function() {
    var url = null;
    if (window.createObjectURL !== undefined) { // basic
        url = window.createObjectURL(this);
    } else if (window.URL !== undefined) { // mozilla(firefox)
        url = window.URL.createObjectURL(this);
    } else if (window.webkitURL !== undefined) { // webkit or chrome
        url = window.webkitURL.createObjectURL(this);
    }
    return url;
}